import { FiSearch } from "react-icons/fi";
import { TfiTimer } from "react-icons/tfi";
import { useEffect, useRef, useState } from "react";
import { inviteServices } from "../../APIServices/UserData/inviteServices";
import { Badge, Button, Card, Col, Collapse, Container, Form, InputGroup, ListGroup, Row } from "react-bootstrap";
import { FaBan, FaClock, FaEnvelope, FaHistory, FaPaperPlane, FaPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import UseToggle from "../../Hooks/UseToggle";
import NoDataHere from "../../Img/nodatahere.png";
import InviteNewMember from "./InviteNewMember";
import { BsSortDown } from "react-icons/bs";
import { FcInvite } from "react-icons/fc";
import ActivityTimeline from "../ActivityTimeline";
import { LuActivity } from "react-icons/lu";
import { ListLoader, WaveLoader } from "../../Hooks/PageLoader";
import { GrOrganization } from "react-icons/gr";
import { RiAccountPinBoxFill } from "react-icons/ri";

const InvitationManagement = ({ auth, isDark, accountList }) => {
  const toggles = UseToggle();
  const AppRef = useRef(null);
  const [invitedMemberList, setInvitedMemberList] = useState([]);
  const [invitedId, setInvitedId] = useState("");
  const [invitedMemberData, setInvitedMemberData] = useState("");
  const [invitedMemberCount, setInvitedMemberCount] = useState(0);
  const [openSort, setOpenSort] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [status, setStatus] = useState("all");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(invitedMemberCount / itemsPerPage);
  const [listLoader, setListLoader] = useState(false)

  const getInvitation = async () => {
    setListLoader(true)
    let data = await inviteServices.getInvitation(auth, status, searchData, pageNumber, itemsPerPage)
    setInvitedMemberList(data?.data || [])
    setInvitedMemberCount(data?.count || 0)
    setListLoader(false)
  }
  const [itemDataLoader, setItemDataLoader] = useState(false);

  const getSingleInvitationData = async (invitedId) => {
    setItemDataLoader(true)
    let data = await inviteServices.getSingleInvitationData(auth, invitedId)
    setInvitedMemberData(data?.data || "")
    setItemDataLoader(false)
  }

  const resendInvitation = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Resend this Invitation?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, resend it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.id = id
        let data = await inviteServices.resendInvitation(auth, userData)
        if (data?.statusCode === 200) {
          getInvitation()
          getSingleInvitationData(id)
        }
      }
    });
  };

  const cancelInvitation = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Cancel this Invitation?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.id = id
        let data = await inviteServices.cancelInvitation(auth, userData)
        if (data?.statusCode === 200) {
          getInvitation()
          getSingleInvitationData(id)
        }
      }
    });
  };

  useEffect(() => {
    getInvitation()
  }, [auth, status, searchData, pageNumber, itemsPerPage]);

  useEffect(() => {
    if (invitedId) {
      getSingleInvitationData(invitedId)
    }
  }, [auth, invitedId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppRef.current && !AppRef.current.contains(event.target)) {
        setOpenSort(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const activities = [
    {
      id: 1,
      time: "09:30 AM",
      title: "User Activate",
      description: "Activate by Roop Chandra",
      type: "success",
    },
    {
      id: 2,
      time: "10:15 AM",
      title: "Assign Member Group",
      description: "Assigned by Roop Chandra",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "User Deactivate",
      description: "Deactivated by Satish Kumar Gautam",
      type: "warning",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "User Activate",
      description: "Activated by Satish Kumar Gautam",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "User Deactivate",
      description: "Deactivated by Satish Kumar Gautam",
      type: "warning",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "User Activate",
      description: "Activated by Satish Kumar Gautam",
      type: "success",
    },
  ];

  return (
    <div className="position-relative">
      <div className="p-2 hstack gap-2 border-bottom">
        <InputGroup>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px", width: "20%" }}
            onChange={(e) => setStatus(e.target.value)}
            value={status}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
            <option value="accepted">Accepted</option>
          </Form.Select>
          <FiSearch className="position-absolute" style={{ top: 11, left: "26.5%", zIndex: 99 }} />
          <Form.Control onChange={(e) => setSearchData(e.target.value)} values={searchData} type="search" className="interactive-input py-2 ps-5" title="Search Here..." style={{ fontSize: 12, width: "70%" }} placeholder={`Search by Email...`} />
        </InputGroup>
        <Button className="text-nowrap hstack gap-2 btn-gradient" title="Send New Invitation" style={{ fontSize: 13 }} onClick={() => toggles.setToggle()}><FaPlus /> New Invitation</Button>
      </div>
      <SplitPane split="vertical" minSize={"25%"} className="position-relative">
        <div style={{ height: "100vh" }}>
          <div className="p-2 pb-1 hstack justify-content-between gap-2">
            <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`} title="Invited Members"><FcInvite /> <span style={{ fontSize: 14 }}>Invited Members ({invitedMemberCount})</span></Button>
            <div className="position-relative">
              <Button variant={openSort ? "primary" : isDark ? "outline-dark" : "outline-light"} ref={AppRef} onClick={() => setOpenSort(!openSort)} className={`${openSort ? "text-white" : isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1`} title="Sort items"><BsSortDown /></Button>
              <Collapse in={openSort}>
                <ListGroup className="position-absolute text-nowrap shadow-sm" style={{ zIndex: 99, right: -9, top: 35, fontSize: 13 }}>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="By Email" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Created" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Modified" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortFor" type="radio" label="Newest First" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortFor" type="radio" label="Oldest First" /></ListGroup.Item>
                </ListGroup>
              </Collapse>
            </div>
          </div>
          <div className="px-2 text-center pb-2">
            <Form.Label className="mb-0" style={{ fontSize: 12, color: "#94a3b8", userSelect: "none" }}>Oldest First | Date Created</Form.Label>
          </div>
          <div className="px-2 overflow-auto pb-2" style={{ height: "calc(100vh - 131px)" }}>
            {listLoader ? <ListLoader /> : invitedMemberList?.length > 0 ? (
              <div className="item-list">
                {invitedMemberList.map((item, index) => {
                  const isActive = invitedId === item?._id;

                  return (
                    <div
                      key={index}
                      className={`member-card border ${isActive ? item?.status === "pending" ? "border-warning bg-warning-subtle" : item?.status === "cancelled" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                      onClick={() => setInvitedId(item?._id)}
                      role="button"
                    >
                      <div className={`avatar ${item?.status === "pending" ? "bg-warning" : item?.status === "cancelled" ? "bg-danger" : "bg-success"}`}>
                        {item?.email?.charAt(0)?.toUpperCase()}
                      </div>
                      <div className="member-info">
                        <div className="member-name">
                          <FaEnvelope /> {item?.email}
                        </div>
                        <div className="member-email">
                          <TfiTimer /> <Moment format="DD MMM YYYY | HH:mm" withTitle>{item?.inVitationDate}</Moment>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="item-empty-state">
                <span>No members found</span>
              </div>
            )}
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          {itemDataLoader ? <WaveLoader /> : invitedMemberData ? (
            <>
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={activities ? 8 : 12} className={`${activities && "border-end"} py-4 overflow-auto`} style={{ height: "calc(100vh - 53px)" }}>
                    <div className={`${!activities ? "w-50 m-auto" : "px-3"}`}>
                      <Card className="shadow-sm border">
                        <Card.Header className="hstack justify-content-between fw-bold border-bottom">
                          <span>Invitation Details</span>
                          <div className="hstack gap-2">
                            {invitedMemberData?.status === "pending" &&
                              <>
                                <Button
                                  onClick={() => cancelInvitation(invitedMemberData?._id)}
                                  variant="outline-danger"
                                  size="sm"
                                  className="hstack gap-1 rounded-1"
                                  style={{ fontSize: 10 }}
                                >
                                  <FaBan /> Cancel
                                </Button>
                                <Button
                                  onClick={() => resendInvitation(invitedMemberData?._id)}
                                  variant="outline-primary"
                                  size="sm"
                                  className="hstack gap-1 rounded-1"
                                  style={{ fontSize: 10 }}
                                >
                                  <FaPaperPlane /> Resend
                                </Button>
                              </>
                            }
                          </div>
                        </Card.Header>

                        <Card.Body>
                          {/* Email */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaEnvelope /> Email
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 13 }}>
                              {invitedMemberData?.email}
                            </div>
                          </div>

                          {/* Invited By */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <GrOrganization /> Invited By
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 13 }}>
                              {invitedMemberData?.invitedBy}
                            </div>
                          </div>

                          {/* Date */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaClock /> Invitation Date | Time
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 12 }}>
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {invitedMemberData?.inVitationDate}
                              </Moment>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaClock /> Accept / Reject Date | Time
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 12 }}>
                              {invitedMemberData?.acceptRejectDate ?
                                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                  {invitedMemberData?.acceptRejectDate}
                                </Moment>
                                : "NA"}
                            </div>
                          </div>

                          {/* Status */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaHistory /> Status
                            </div>
                            <Badge
                              bg={
                                invitedMemberData?.status === "pending"
                                  ? "warning"
                                  : invitedMemberData?.status === "cancelled"
                                    ? "danger"
                                    : "success"
                              }
                              className="rounded-1"
                            >
                              {invitedMemberData?.status === "pending"
                                ? "Pending"
                                : invitedMemberData?.status === "cancelled"
                                  ? "Cancelled"
                                  : "Accepted"}
                            </Badge>
                          </div>
                          {/* Assign Accounts */}
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <RiAccountPinBoxFill /> Assign Accounts
                            </div>
                          </div>
                          {(invitedMemberData?.totalAccount || [])?.map(item => (
                            <div className="fw-semibold" style={{ fontSize: 14 }}>
                              <Badge
                                bg="primary"
                                className="rounded-1"
                              >
                                {item?.name}
                              </Badge>
                            </div>
                          ))}
                        </Card.Body>
                      </Card>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={4} className="p-0">
                    <Form.Label className="fw-bold pt-4 px-4 hstack gap-2"><LuActivity /> Activity</Form.Label>
                    <div className="overflow-auto ps-4" style={{ height: "calc(100vh - 100px)" }}>
                      <ActivityTimeline activities={activities} />
                    </div>
                  </Form.Group>
                </Row>
              </Container>
            </>
          ) : (
            <span className="small hstack justify-content-center h-100">
              <div className="text-center" style={{ pointerEvents: "none", userSelect: "none" }}>
                <img src={NoDataHere} style={{ width: 200, opacity: .1 }} alt="" />
                <p className="text-muted">There are no invitation.</p>
              </div>
            </span>
          )}
        </div>
      </SplitPane>
      <InviteNewMember
        auth={auth}
        isDark={isDark}
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Invite New Member"
        accountList={accountList}
        getInvitation={getInvitation}
      />
    </div>
  );
};

export default InvitationManagement;
